import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "viewBox": "-7.5 -8 1244.671875 576.3804931640625",
        "style": {
          "maxWidth": "1244.671875px"
        },
        "aria-labelled-by": ["chart-title-mermaid-1673357383072", "chart-desc-mermaid-1673357383072"],
        "role": "img",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "100%",
        "id": "mermaid-1673357383072"
      }}><title parentName="svg" {...{
          "id": "chart-title-mermaid-1673357383072"
        }}></title><desc parentName="svg" {...{
          "id": "chart-desc-mermaid-1673357383072"
        }}></desc><style parentName="svg">{`#mermaid-1673357383072 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1673357383072 .error-icon{fill:#552222;}#mermaid-1673357383072 .error-text{fill:#552222;stroke:#552222;}#mermaid-1673357383072 .edge-thickness-normal{stroke-width:2px;}#mermaid-1673357383072 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1673357383072 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1673357383072 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1673357383072 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1673357383072 .marker{fill:#333333;stroke:#333333;}#mermaid-1673357383072 .marker.cross{stroke:#333333;}#mermaid-1673357383072 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1673357383072 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1673357383072 .cluster-label text{fill:#333;}#mermaid-1673357383072 .cluster-label span{color:#333;}#mermaid-1673357383072 .label text,#mermaid-1673357383072 span{fill:#333;color:#333;}#mermaid-1673357383072 .node rect,#mermaid-1673357383072 .node circle,#mermaid-1673357383072 .node ellipse,#mermaid-1673357383072 .node polygon,#mermaid-1673357383072 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1673357383072 .node .label{text-align:center;}#mermaid-1673357383072 .node.clickable{cursor:pointer;}#mermaid-1673357383072 .arrowheadPath{fill:#333333;}#mermaid-1673357383072 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1673357383072 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1673357383072 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1673357383072 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1673357383072 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1673357383072 .cluster text{fill:#333;}#mermaid-1673357383072 .cluster span{color:#333;}#mermaid-1673357383072 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1673357383072 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1673357383072 .sgraph>*{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1673357383072 .sgraph span{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1673357383072 .plain>*{fill:#ddd!important;stroke:#fff!important;stroke-width:4px!important;color:#000!important;}#mermaid-1673357383072 .plain span{fill:#ddd!important;stroke:#fff!important;stroke-width:4px!important;color:#000!important;}#mermaid-1673357383072 .k8s>*{fill:#326ce5!important;stroke:#fff!important;stroke-width:4px!important;color:#fff!important;}#mermaid-1673357383072 .k8s span{fill:#326ce5!important;stroke:#fff!important;stroke-width:4px!important;color:#fff!important;}#mermaid-1673357383072 .cluster>*{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}#mermaid-1673357383072 .cluster span{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}`}</style><g parentName="svg"><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "9",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 0 L 10 5 L 0 10 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "0",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 5 L 10 10 L 10 0 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "11",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleEnd"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "-1",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleStart"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "12",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "-1",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><g parentName="g" {...{
            "className": "root"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "transform": "translate(-7.5, -8)",
                "className": "root"
              }}><g parentName="g" {...{
                  "className": "clusters"
                }}><g parentName="g" {...{
                    "id": "Wrapper",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "560.3804836273193",
                      "width": "1228.671875",
                      "y": "8",
                      "x": "8",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(622.3359375, 13)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "PluginServerAsync",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "520.3804836273193",
                      "width": "654.03125",
                      "y": "28",
                      "x": "557.640625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(884.65625, 33)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "MainThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "480.38048362731934",
                      "width": "217.5",
                      "y": "48",
                      "x": "582.640625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(643.5234375, 53)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "95.734375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Main thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "WorkerThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "394",
                      "width": "216.265625",
                      "y": "76.75",
                      "x": "970.40625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1021.5859375, 81.75)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "113.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker thread`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "edgePaths"
                }}><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Kafka LE-KafkaConsumer",
                    "id": "L-Kafka-KafkaConsumer-0",
                    "d": "M321.515625,114L341.1510416666667,113.91666666666667C360.7864583333333,113.83333333333333,400.0572916666667,113.66666666666667,439.4114583333333,113.58333333333333C478.765625,113.5,518.203125,113.5,542.0885416666666,113.5C565.9739583333334,113.5,574.3072916666666,113.5,584.4231770833334,113.5C594.5390625,113.5,606.4375,113.5,612.38671875,113.5L618.3359375,113.5"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-0",
                    "d": "M764.4453125,100.40053879310345L770.39453125,99.3337823275862C776.34375,98.26702586206898,788.2421875,96.13351293103449,798.3580729166666,95.06675646551724C808.4739583333334,94,816.8072916666666,94,829.4883388643067,110C842.169386061947,126,859.1981471238938,158,867.7125276548672,174L876.2269081858407,190"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-1",
                    "d": "M764.4453125,113.83588362068966L770.39453125,113.86323635057471C776.34375,113.89058908045978,788.2421875,113.94529454022988,798.3580729166666,113.97264727011493C808.4739583333334,114,816.8072916666666,114,829.1640905017921,126.66666666666667C841.5208893369175,139.33333333333334,857.901153673835,164.66666666666666,866.0912858422938,177.33333333333334L874.2814180107526,190"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-2",
                    "d": "M764.4453125,127.27122844827586L770.39453125,128.39269037356323C776.34375,129.51415229885058,788.2421875,131.75707614942527,798.3580729166666,132.87853807471265C808.4739583333334,134,816.8072916666666,134,828.662171803653,143.33333333333334C840.5170519406392,152.66666666666666,855.8934788812785,171.33333333333334,863.5816923515981,180.66666666666666L871.2699058219179,190"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-AsyncHandlers",
                    "id": "L-Piscina-AsyncHandlers-0",
                    "d": "M900.1426420454545,190L907.6865767045455,181.375C915.2305113636363,172.75,930.3183806818182,155.5,942.0289820075758,146.875C953.7395833333334,138.25,962.0729166666666,138.25,970.40625,138.25C978.7395833333334,138.25,987.0729166666666,138.25,991.2395833333334,138.25L995.40625,138.25"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Schedule LE-Piscina",
                    "id": "L-Schedule-Piscina-0",
                    "d": "M735.65625,197.5L746.4036458333334,197.5C757.1510416666666,197.5,778.6458333333334,197.5,793.5598958333334,197.5C808.4739583333334,197.5,816.8072916666666,197.5,825.140625,198.15826512494047C833.4739583333334,198.8165302498809,841.8072916666666,200.1330604997618,845.9739583333334,200.79132562470227L850.140625,201.4495907496427"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-Scheduled",
                    "id": "L-Piscina-Scheduled-0",
                    "d": "M920.40625,221.46027673119397L924.5729166666666,223.1752306093283C928.7395833333334,224.89018448746265,937.0729166666666,228.32009224373132,945.40625,230.03504612186566C953.7395833333334,231.75,962.0729166666666,231.75,972.11328125,231.75C982.1536458333334,231.75,993.9010416666666,231.75,999.7747395833334,231.75L1005.6484375,231.75"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Postgres LE-Graphile",
                    "id": "L-Postgres-Graphile-0",
                    "d": "M315.8203125,281.5L336.4049479166667,281.5C356.9895833333333,281.5,398.1588541666667,281.5,438.4622395833333,281.5C478.765625,281.5,518.203125,281.5,542.0885416666666,281.5C565.9739583333334,281.5,574.3072916666666,281.5,582.640625,281.5C590.9739583333334,281.5,599.3072916666666,281.5,603.4739583333334,281.5L607.640625,281.5"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Graphile LE-Piscina",
                    "id": "L-Graphile-Piscina-0",
                    "d": "M775.140625,281.5L779.3072916666666,281.5C783.4739583333334,281.5,791.8072916666666,281.5,800.140625,281.5C808.4739583333334,281.5,816.8072916666666,281.5,828.7091635206934,271.9166666666667C840.6110353747204,262.3333333333333,856.0814457494407,243.16666666666666,863.8166509368008,233.58333333333334L871.5518561241611,224"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-Jobs",
                    "id": "L-Piscina-Jobs-0",
                    "d": "M894.6735093390805,224L903.1289661159004,239.29166666666666C911.5844228927203,254.58333333333334,928.4953364463603,285.1666666666667,941.1174598898468,300.4583333333333C953.7395833333334,315.75,962.0729166666666,315.75,975.7786458333334,315.75C989.484375,315.75,1008.5625,315.75,1018.1015625,315.75L1027.640625,315.75"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-IngestionServer LE-Kafka",
                    "id": "L-IngestionServer-Kafka-0",
                    "d": "M177.578125,113.5L181.74479166666666,113.5C185.91145833333334,113.5,194.24479166666666,113.5,202.66145833333334,113.58333333333333C211.078125,113.66666666666667,219.578125,113.83333333333333,223.828125,113.91666666666667L228.078125,114"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Django LE-Redis",
                    "id": "L-Django-Redis-0",
                    "d": "M141.1171875,392.38048362731934L151.36067708333334,392.38048362731934C161.60416666666666,392.38048362731934,182.09114583333334,392.38048362731934,199.43880208333334,392.38048362731934C216.78645833333334,392.38048362731934,230.99479166666666,392.38048362731934,238.09895833333334,392.38048362731934L245.203125,392.38048362731934"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Redis LE-PubSub",
                    "id": "L-Redis-PubSub-0",
                    "d": "M303.390625,384.3697157559849L326.046875,378.1314700989307C348.703125,371.8932244418765,394.015625,359.4167331277681,436.390625,353.1784874707139C478.765625,346.94024181365967,518.203125,346.94024181365967,542.0885416666666,346.94024181365967C565.9739583333334,346.94024181365967,574.3072916666666,346.94024181365967,590.3385416666666,351.8977547854756C606.3697916666666,356.8552677572916,630.0989583333334,366.77029370092345,641.9635416666666,371.7278066727394L653.828125,376.6853196445553"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Redis LE-PubSub",
                    "id": "L-Redis-PubSub-1",
                    "d": "M303.390625,402.6054410217522L326.046875,410.56794812268004C348.703125,418.53045522360793,394.015625,434.4554694254636,436.390625,442.41797652639144C478.765625,450.38048362731934,518.203125,450.38048362731934,542.0885416666666,450.38048362731934C565.9739583333334,450.38048362731934,574.3072916666666,450.38048362731934,591.2864583333334,443.547150293986C608.265625,436.71381696065265,633.890625,423.047150293986,646.703125,416.21381696065265L659.515625,409.38048362731934"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PubSub LE-Piscina",
                    "id": "L-PubSub-Piscina-0",
                    "d": "M728.953125,392.38048362731934L740.8177083333334,392.38048362731934C752.6822916666666,392.38048362731934,776.4114583333334,392.38048362731934,792.4427083333334,392.38048362731934C808.4739583333334,392.38048362731934,816.8072916666666,392.38048362731934,830.0770309730043,364.3170696894328C843.3467702793419,336.2536557515462,861.5529155586837,280.12682787577313,870.6559881983547,252.06341393788657L879.7590608380257,224"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-ReloadPlugins",
                    "id": "L-Piscina-ReloadPlugins-0",
                    "d": "M890.3278642614339,224L899.5075952178616,254.875C908.6873261742893,285.75,927.0467880871447,347.5,940.393185710239,378.375C953.7395833333334,409.25,962.0729166666666,409.25,973.2330729166666,409.25C984.3932291666666,409.25,998.3802083333334,409.25,1005.3736979166666,409.25L1012.3671875,409.25"
                  }}></path></g><g parentName="g" {...{
                  "className": "edgeLabels"
                }}><g parentName="g" {...{
                    "transform": "translate(439.328125, 113.5)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-93.3125, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "186.625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`clickhouse_events_json`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "nodes"
                }}><g parentName="g" {...{
                    "transform": "translate(274.296875, 392.38048362731934)",
                    "id": "flowchart-Redis-104",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-29.09375,-28.911463664278404)",
                      "d": "M 0,7.940975776185602 a 29.09375,7.940975776185602 0,0,0 58.1875 0 a 29.09375,7.940975776185602 0,0,0 -58.1875 0 l 0,41.9409757761856 a 29.09375,7.940975776185602 0,0,0 58.1875 0 l 0,-41.9409757761856",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-21.59375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "43.1875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Redis`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(274.296875, 113.5)",
                    "id": "flowchart-Kafka-106",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(691.390625, 113.5)",
                    "id": "flowchart-KafkaConsumer-109",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "146.109375",
                      "y": "-17",
                      "x": "-73.0546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.5546875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "131.109375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka Consumer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(885.2734375, 207)",
                    "id": "flowchart-Piscina-111",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "70.265625",
                      "y": "-17",
                      "x": "-35.1328125",
                      "ry": "0",
                      "rx": "0",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-27.6328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "55.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Piscina`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1078.5390625, 138.25)",
                    "id": "flowchart-AsyncHandlers-120",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "53",
                      "width": "166.265625",
                      "y": "-26.5",
                      "x": "-83.1328125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-75.6328125, -19)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "38",
                        "width": "151.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`runAsyncHandlers`}<br parentName="span"></br>{`onEvent,webhooks`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(691.390625, 197.5)",
                    "id": "flowchart-Schedule-112",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "88.53125",
                      "y": "-17",
                      "x": "-44.265625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-36.765625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "73.53125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Schedule`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1078.5390625, 231.75)",
                    "id": "flowchart-Scheduled-121",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "145.78125",
                      "y": "-17",
                      "x": "-72.890625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.390625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "130.78125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Scheduled tasks`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(274.296875, 281.5)",
                    "id": "flowchart-Postgres-105",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-41.5234375,-31.96901990236575)",
                      "d": "M 0,9.979346601577168 a 41.5234375,9.979346601577168 0,0,0 83.046875 0 a 41.5234375,9.979346601577168 0,0,0 -83.046875 0 l 0,43.97934660157717 a 41.5234375,9.979346601577168 0,0,0 83.046875 0 l 0,-43.97934660157717",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-34.0234375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "68.046875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Postgres`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(691.390625, 281.5)",
                    "id": "flowchart-Graphile-110",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "167.5",
                      "y": "-17",
                      "x": "-83.75",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-76.25, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "152.5"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Graphile job queue`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1078.5390625, 315.75)",
                    "id": "flowchart-Jobs-122",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "101.796875",
                      "y": "-17",
                      "x": "-50.8984375",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-43.3984375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "86.796875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Plugin jobs`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(105.2890625, 113.5)",
                    "id": "flowchart-IngestionServer-108",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "144.578125",
                      "y": "-17",
                      "x": "-72.2890625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-64.7890625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "129.578125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Ingestion server`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(105.2890625, 392.38048362731934)",
                    "id": "flowchart-Django-107",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "71.65625",
                      "y": "-17",
                      "x": "-35.828125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-28.328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "56.65625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Django`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(691.390625, 392.38048362731934)",
                    "id": "flowchart-PubSub-114",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "75.125",
                      "y": "-17",
                      "x": "-37.5625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-30.0625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "60.125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`PubSub`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1078.5390625, 409.25)",
                    "id": "flowchart-ReloadPlugins-123",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "53",
                      "width": "132.34375",
                      "y": "-26.5",
                      "x": "-66.171875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-58.671875, -19)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "38",
                        "width": "117.34375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Reload plugins`}<br parentName="span"></br>{`Reload actions`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(691.390625, 476.38048362731934)",
                    "id": "flowchart-HttpServer-113",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "113.5",
                      "y": "-17",
                      "x": "-56.75",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-49.25, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "98.5"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`HTTP Server`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      